// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3z6vF","buttons":"PendingPaymentAlert_buttons__AlRgA"};